import * as stateManagement from '#packages/stateManagement';
import * as util from '#packages/util';
import experiment from 'experiment';

import type {
  MapStateToProps,
  MapDispatchToProps,
  Dispatch,
  StateMapperArgs,
} from 'types/redux';
import type { EditorAPI } from '#packages/editorAPI';
import type { BiEventDefinition, BiEventFields } from 'types/bi';
import type { PublishPanelOwnProps } from './publishPanel';
import { StudioMigrationManagerKey } from '#packages/apis';

export interface PublishPanelDispatchProps {
  openPanel: (panelName: string) => void;
  openAccountSettings: (path: string) => void;
  sendBi: (event: BiEventDefinition, parameters: BiEventFields) => void;
}

export interface PublishPanelStateProps {
  editorAPI: EditorAPI;
  canUserPublish: boolean;
  isSitePublished: boolean;
  sitePublicUrl: string;
  isCustomTemplate: boolean;
  isCustomTemplatePublished: boolean;
  shouldBlockPublishForStudioMigration: boolean;
}

const mapStateToProps: MapStateToProps<
  PublishPanelStateProps,
  PublishPanelOwnProps
> = ({ editorAPI, state }) => {
  const customTemplateSelectors = stateManagement.customTemplate.selectors;

  const studioMigrationAPI = editorAPI.host.getAPI(StudioMigrationManagerKey);
  const shouldBlockPublishForStudioMigration =
    studioMigrationAPI.shouldBlockPublishForStudioMigration();

  return {
    editorAPI,
    canUserPublish: editorAPI.savePublish.canUserPublish(),
    isSitePublished: editorAPI?.dsRead.generalInfo.isSitePublished() || false,
    sitePublicUrl: editorAPI.site.getSitePublicUrl() || '',
    isCustomTemplate:
      experiment.isOpen('se_customTemplateEditIndication') &&
      util.editorModel.isCustomTemplate,
    isCustomTemplatePublished:
      customTemplateSelectors.getIsCustomTemplatePublished(state),
    shouldBlockPublishForStudioMigration,
  };
};

const getEditorAPI = (
  dispatch: Dispatch,
  getState: () => stateManagement.EditorState,
  { editorAPI }: StateMapperArgs,
): EditorAPI => editorAPI;

export const mapDispatchToProps: MapDispatchToProps<
  PublishPanelDispatchProps,
  PublishPanelOwnProps
> = (dispatch: Dispatch) => {
  const editorAPI = dispatch(getEditorAPI);
  return {
    openPanel: (panelName: string) => {
      dispatch(stateManagement.panels.actions.updateOrOpenPanel(panelName));
    },
    openAccountSettings: (path: string) => {
      editorAPI.account.openSettings({ path });
    },
    sendBi: editorAPI.bi.event,
  };
};

export { mapStateToProps };
